/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { PaymentMethodsState } from './types';
import { RootState } from '../types';
import { getDefaultState } from '../utils';

export const state: PaymentMethodsState = {
  paymentMethods: { ...getDefaultState() },
  setupMethods: { ...getDefaultState() },
  checkoutMethods: { ...getDefaultState() },
  rechargeMethods: { ...getDefaultState() },
  preferableTransactionAmount: { ...getDefaultState() },
  adyenSPM: { ...getDefaultState() },
  lagoPaymentMethods: [],
  lagoDefaultPaymentMethod: null,
  sdk: null,
  error: false,
};

const namespaced = true;

export const paymentMethods: Module<PaymentMethodsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
